import axios from 'axios';
import { SERVER_URL } from 'Constants';
import { AbortSignals } from 'Hooks/useAbortSignals';
import { UserEntity } from 'Models/Entities';
import { UserModelType, UserRoles } from 'Models/Enums';

export interface IInvitedUserResponse {
    id: string;
    email: string;
    userName: string;
    firstName: string;
    lastName: string;
}

export const inviteUser = (
	abortSignals: AbortSignals,
	user: UserEntity,
) => {
	return axios.post<IInvitedUserResponse>(
		`${SERVER_URL}/api/register/invite-user`,
		user.toJSON(),
		{ cancelToken: abortSignals.axiosCancelToken.token },
	);
};

export const inviteStaffUser = <T, >(
	abortSignals: AbortSignals,
	user: UserModelType<T>,
	groups: UserRoles[],
) => {
	return axios.post<IInvitedUserResponse>(
		`${SERVER_URL}/api/register/invite-staff`,
		{
			...user.toJSON(),
			groups,
		},
		{ cancelToken: abortSignals.axiosCancelToken.token },
	);
};
